/**
 * UNIFIED APP SHELL LOADING STATE
 *
 * Consistent, intentional loading experience shown while route access
 * state is resolving. Prevents blank screens, scattered spinners,
 * and flash of wrong content.
 *
 * Design: minimal branded loading with top progress bar.
 */

import { Loader2 } from "lucide-react";
import { LaunchSkeleton } from "@/components/launch/LaunchSkeleton";

export function AppShellLoading() {
  const isLaunchRoute = typeof window !== "undefined" && ["/", "/launch"].includes(window.location.pathname);

  if (isLaunchRoute) {
    return <LaunchSkeleton />;
  }

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background">
      {/* Top loading bar */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <div className="h-1 w-full overflow-hidden bg-muted">
          <div
            className="h-full bg-primary animate-pulse"
            style={{ width: "60%", transition: "width 0.3s ease" }}
          />
        </div>
      </div>

      {/* Centered spinner */}
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
}
